export const adminList = [
  {
    email: "alekh@rankspro.io",
    isAdmin: true,
    isPerformAction: true,
  },
  {
    email: "ravi@rankspro.io",
    isAdmin: true,
    isPerformAction: false,
  },
  {
    email: "singhashish1.sh@gmail.com",
    isAdmin: true,
    isPerformAction: true,
  },
];
